module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper"
  }, [_c('div', [_c('div', {
    class: _vm.UserContext.UserType == 1 ? 'sidebar-container' : 'sidebar-container sidebar-container2',
    style: ({
      width: _vm.Iscollapse ? '70px !important' : '15% !important',
      'z-index': 999,
    })
  }, [_c('div', [(!_vm.Iscollapse) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "margin": "auto",
      "padding": "20px"
    },
    attrs: {
      "src": require("../assets/img/MKD-logo.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticStyle: {
      "width": "70%",
      "margin-left": "15%",
      "margin-top": "15%",
      "margin-bottom": "20px"
    },
    attrs: {
      "src": require("../assets/img/smallLogo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-scrollbar', {
    staticClass: "indexScroll",
    attrs: {
      "wrapClass": "scrollbar-wrapper"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    class: _vm.UserContext.UserType == 1 ? 'customerHorizontalMenu' : 'horizontalMenu',
    staticStyle: {
      "height": "100% !important"
    },
    attrs: {
      "mode": "vertical",
      "show-timeout": 6000,
      "hide-timeout": 6000,
      "collapse": _vm.Iscollapse
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_c('el-menu-item', {
    class: _vm.UserContext.UserType == 1 ? 'CustomSidebar' : 'CustomSidebar2',
    attrs: {
      "index": "/",
      "default-active": ""
    },
    on: {
      "click": function($event) {
        return _vm.openDashboard()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "18px",
      "margin-right": "14px",
      "margin-left": "4px"
    },
    attrs: {
      "src": require("../assets/img/Dashboard.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "navAddText",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.gets('$首页')))])]), _vm._v(" "), (_vm.UserContext.UserType == 1) ? _c('el-menu-item', {
    class: _vm.UserContext.UserType == 1 ? 'CustomSidebar' : 'CustomSidebar2',
    attrs: {
      "default-active": ""
    },
    on: {
      "click": function($event) {
        return _vm.toMall()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "18px",
      "margin-right": "14px",
      "margin-left": "4px"
    },
    attrs: {
      "src": require("../assets/img/Mall.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "navAddText",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.gets('$商城')))])]) : _vm._e(), _vm._v(" "), (!_vm.Iscollapse) ? _c('el-menu-item', {
    class: _vm.UserContext.UserType == 1 ? 'CustomSidebar' : 'CustomSidebar2',
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('template', {
    slot: "title"
  }, [(_vm.language == 'EN') ? _c('span', {
    staticClass: "navAddText",
    staticStyle: {
      "font-weight": "lighter",
      "font-family": "Helvetica light",
      "letter-spacing": "0.5px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("MANAGEMENT")]) : _c('span', {
    staticClass: "navAddText",
    staticStyle: {
      "font-weight": "lighter",
      "font-family": "Helvetica light",
      "letter-spacing": "0.5px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("管理")])])], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.d.navs), function(i) {
    return (_vm.IsShowNavs(i.twoNavs) && i.name != '推广管理' && i.name != '财务管理' && i.name != '推广' && i.name != 'Affiliate' && i.name != 'Affiliation' && i.name != 'Financial') ? _c('el-submenu', {
      attrs: {
        "index": i.name
      }
    }, [_c('template', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!i.name != '推广' && i.name != 'Affiliate' && i.name != 'Affiliation' && i.name != 'Account '),
        expression: "!i.name!='推广'&&i.name!='Affiliate'&&i.name!='Affiliation'&&i.name!='Account '"
      }],
      slot: "title"
    }, [(i.name == '店铺管理' || i.name == 'Shop Setting') ? _c('img', {
      staticStyle: {
        "width": "18px",
        "margin-right": "14px",
        "margin-left": "4px"
      },
      attrs: {
        "src": require("../assets/img/Shop.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (i.name == '商城' || i.name == 'Mall') ? _c('img', {
      staticStyle: {
        "width": "18px",
        "margin-right": "14px",
        "margin-left": "4px"
      },
      attrs: {
        "src": require("../assets/img/Mall.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (i.name == '订单' || i.name == '订单管理' || i.name == 'Order') ? _c('img', {
      staticStyle: {
        "width": "16px",
        "margin-right": "14px",
        "margin-left": "4px"
      },
      attrs: {
        "src": require("../assets/img/Order.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (i.name == '采购管理' || i.name == 'Purchasing') ? _c('img', {
      staticStyle: {
        "width": "18px",
        "margin-right": "14px"
      },
      attrs: {
        "src": require("../assets/img/Purchasing.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (i.name == '仓库' || i.name == '仓库管理' || i.name == 'Warehouse' || i.name == 'Warehouse ') ? _c('img', {
      staticStyle: {
        "width": "18px",
        "margin-right": "14px",
        "margin-left": "2px"
      },
      attrs: {
        "src": require("../assets/img/Warehouse.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (i.name == '财务管理' || i.name == 'Financial') ? _c('img', {
      staticStyle: {
        "width": "16px",
        "margin-right": "14px",
        "margin-left": "2px"
      },
      attrs: {
        "src": require("../assets/img/Financial.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (i.name == '账户管理' || i.name == '客户管理' || i.name == 'Customer ' || i.name == 'Account ') ? _c('img', {
      staticStyle: {
        "width": "19px",
        "margin-right": "14px",
        "margin-left": "1px"
      },
      attrs: {
        "src": require("../assets/img/Customer.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (i.name == '推广管理' || i.name == '推广' || i.name == 'Affiliation' || i.name == 'Affiliate') ? _c('img', {
      staticStyle: {
        "width": "17px",
        "margin-right": "14px",
        "margin-left": "2px"
      },
      attrs: {
        "src": require("../assets/img/Affiliation.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (i.name == '系统管理' || i.name == 'System') ? _c('img', {
      staticStyle: {
        "width": "16px",
        "margin-right": "14px",
        "margin-left": "4px"
      },
      attrs: {
        "src": require("../assets/img/setting.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (i.name == '物流管理' || i.name == 'Operation') ? _c('img', {
      staticStyle: {
        "width": "16px",
        "margin-right": "14px",
        "margin-left": "2px"
      },
      attrs: {
        "src": require("../assets/img/Operation.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (i.name == '渠道管理' || i.name == 'Channel') ? _c('img', {
      staticStyle: {
        "width": "16px",
        "margin-right": "14px",
        "margin-left": "4px"
      },
      attrs: {
        "src": require("../assets/img/channel.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(i.name))])]), _vm._v(" "), _vm._l((i.twoNavs), function(c) {
      return (_vm.IsRight(c.moduleID)) ? _c('el-menu-item', {
        attrs: {
          "tag": i.name + '/' + c.name,
          "index": i.name + '/' + c.name
        },
        on: {
          "click": function($event) {
            return _vm.openNav(i, c)
          }
        }
      }, [_vm._v(_vm._s(c.name))]) : _vm._e()
    })], 2) : _vm._e()
  }), _vm._v(" "), (!_vm.Iscollapse) ? _c('el-menu-item', {
    class: _vm.UserContext.UserType == 1 ? 'CustomSidebar' : 'CustomSidebar2',
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('template', {
    slot: "title"
  }, [(_vm.language == 'EN') ? _c('span', {
    staticClass: "navAddText",
    staticStyle: {
      "font-weight": "lighter",
      "font-family": "Helvetica light",
      "letter-spacing": "0.5px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("PERSONAL")]) : _c('span', {
    staticClass: "navAddText",
    staticStyle: {
      "font-weight": "lighter",
      "font-family": "Helvetica light",
      "letter-spacing": "0.5px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("个人")])])], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.d.navs), function(i) {
    return (_vm.IsShowNavs(i.twoNavs) && i.name == '推广管理' || i.name == '财务管理' || i.name == '推广' || i.name == 'Affiliate' || i.name == 'Affiliation' || i.name == 'Financial') ? _c('el-submenu', {
      attrs: {
        "index": i.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(i.name == '账户管理' || i.name == '客户管理' || i.name == 'Customer ' || i.name == 'Account ') ? _c('img', {
      staticStyle: {
        "width": "19px",
        "margin-right": "14px",
        "margin-left": "1px"
      },
      attrs: {
        "src": require("../assets/img/Customer.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (i.name == '推广管理' || i.name == '推广' || i.name == 'Affiliation' || i.name == 'Affiliate') ? _c('img', {
      staticStyle: {
        "width": "17px",
        "margin-right": "14px",
        "margin-left": "2px"
      },
      attrs: {
        "src": require("../assets/img/Affiliation.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (i.name == '财务管理' || i.name == 'Financial') ? _c('img', {
      staticStyle: {
        "width": "16px",
        "margin-right": "14px",
        "margin-left": "2px"
      },
      attrs: {
        "src": require("../assets/img/Financial.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(i.name))])]), _vm._v(" "), _vm._l((i.twoNavs), function(c) {
      return (_vm.IsRight(c.moduleID)) ? _c('el-menu-item', {
        attrs: {
          "tag": i.name + '/' + c.name,
          "index": i.name + '/' + c.name
        },
        on: {
          "click": function($event) {
            return _vm.openNav(i, c)
          }
        }
      }, [_vm._v(_vm._s(c.name))]) : _vm._e()
    })], 2) : _vm._e()
  }), _vm._v(" "), (!_vm.Iscollapse && _vm.UserContext.UserType == 1) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "cursor": "pointer",
      "left": "16%",
      "margin-top": "35%"
    }
  }, [_c('img', {
    staticClass: "serviceImg",
    attrs: {
      "src": require("../assets/img/service.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.toMyQusetion()
      }
    }
  }), _vm._v(" "), (_vm.language == 'EN') ? _c('div', {
    staticClass: "servicePositionText"
  }, [_vm._v(_vm._s(_vm.gets('$帮助')))]) : _c('div', {
    staticClass: "servicePositionText",
    staticStyle: {
      "right": "45%"
    }
  }, [_vm._v(_vm._s(_vm.gets('$帮助')))])]) : _vm._e(), _vm._v(" "), (_vm.Iscollapse && _vm.UserContext.UserType == 1) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "cursor": "pointer",
      "bottom": "0",
      "left": "8%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70%",
      "margin-bottom": "17%"
    },
    attrs: {
      "src": require("../assets/img/smallServiec.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.toMyQusetion()
      }
    }
  })]) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-container",
    style: ({
      'margin-left': _vm.Iscollapse ? '70px !important' : '15% !important',
      'background-color': '#F3F7F9',
      'padding-top': '70px'
    })
  }, [_c('div', [_c('div', {
    style: ({
      'width': _vm.Iscollapse ? '97%' : '85%',
      'background': '#fff',
      'height': '70px',
      'display': 'flex',
      'justify-content': 'space-between',
      'position': 'fixed',
      'top': '0',
      'z-index': '5',
    })
  }, [(_vm.UserContext.UserType == 1) ? _c('div', {
    staticStyle: {
      "height": "100%",
      "display": "flex",
      "align-items": "center",
      "margin-left": "40px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.isC
    }
  }, [_c('img', {
    staticStyle: {
      "width": "23px"
    },
    attrs: {
      "src": require("../../src/assets/img/nav_menu.png"),
      "alt": ""
    }
  })]) : _c('div', {
    staticStyle: {
      "height": "100%",
      "display": "flex",
      "align-items": "center",
      "margin-left": "40px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.isC
    }
  }, [_c('img', {
    staticStyle: {
      "width": "23px"
    },
    attrs: {
      "src": require("../../src/assets/img/nav_menu2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "height": "100%",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.showNotice()
      }
    }
  }, [_c('img', {
    staticClass: "el-icon-bell",
    staticStyle: {
      "width": "20px",
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../assets/img/nav_bellicon.png")
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNoticeData),
      expression: "showNoticeData"
    }],
    staticClass: "news-list",
    class: _vm.UserContext.UserType == 1 ? 'news-list2 animated' : 'news-list3 animated'
  }, [_c('ul', _vm._l((_vm.SearchSys_New), function(o) {
    return _c('li', {
      key: o.ID,
      staticStyle: {
        "padding": "5px 0px",
        "border-bottom": "1px solid rgba(120, 130, 140, 0.13)",
        "cursor": "pointer"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      },
      on: {
        "click": function($event) {
          return _vm.ToNew(o.ID)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-news",
      staticStyle: {
        "font-size": "27px",
        "margin": "0px 20px",
        "color": "rgb(56, 121, 237)"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('div', {
      staticStyle: {
        "line-height": "25px"
      }
    }, [_vm._v(_vm._s(o.Title))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "20px",
        "font-size": "12px",
        "color": "#67757c"
      }
    }, [_vm._v(_vm._s(o.OperatorTime))])])])])
  }), 0)])])], 1), _vm._v(" "), _c('lang-select', {
    staticClass: "set-language",
    staticStyle: {
      "color": "#000",
      "cursor": "pointer",
      "margin": "0px 30px"
    }
  }), _vm._v(" "), _c('el-dropdown', {
    staticClass: "international",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.UserCommand
    }
  }, [_c('div', [_c('span', {
    staticClass: "el-dropdown-link",
    staticStyle: {
      "height": "100%",
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.UserContext) ? _c('span', {
    staticStyle: {
      "margin-left": "40px",
      "width": "max-content",
      "cursor": "pointer"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.UserContext.LastName) + " " + _vm._s(_vm.UserContext.FirstName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.UserContext.Code))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userBG"
  }, [_vm._v("\n                                " + _vm._s(_vm.NameFirst) + "\n                            ")])])]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "User"
    }
  }, [_vm._v(_vm._s(_vm.gets('$个人信息')) + "  ")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "Exit"
    }
  }, [_vm._v(_vm._s(_vm.gets('$注销')))])], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tags-view-container",
    style: ({
      'width': _vm.Iscollapse ? '96% !important' : '85% !important',
      'z-index': '4',
      'position': 'fixed',
      'top': '70px',
      'overflow': 'hidden',
    })
  }, [_c('scroll-pane', {
    ref: "scrollPane",
    staticClass: "tags-view-wrapper acrossTab"
  }, [_c('a', {
    ref: "tag",
    staticClass: "tags-view-item",
    class: _vm.d.thisNav.url == '/Root' ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.toNav({
          "name": "首页",
          "tag": "Root",
          "url": "/Root",
          "moduleID": -10000000
        })
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.gets("$首页")) + "\n              \n            ")]), _vm._v(" "), _vm._l((_vm.d.openNavs), function(i) {
    return [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i.name != '首页' && i.name != 'Home '),
        expression: "i.name!='首页'&&i.name!='Home '"
      }],
      ref: "tag",
      refInFor: true,
      staticClass: "tags-view-item",
      class: i == _vm.d.thisNav ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.toNav(i)
        }
      }
    }, [_vm._v("\n            " + _vm._s(i.name) + "\n            "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i.name != '首页' && i.name != 'Home '),
        expression: "i.name!='首页'&&i.name!='Home '"
      }],
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.closeNav(i)
        }
      }
    })])]
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "app-main",
    staticStyle: {
      "z-index": "998",
      "background-color": "rgb(243, 247, 249)",
      "margin": "30px 30px",
      "margin-top": "92px",
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "frame_right",
    attrs: {
      "id": "frame_right"
    }
  }, _vm._l((_vm.openWindows), function(i) {
    return _c('router-view', {
      staticClass: "fadeInOut_",
      class: {
        Hide: i != _vm.thisWindow || i.IsShow
      },
      attrs: {
        "name": i.tag,
        "tag": i.tag
      }
    })
  }), 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify"
  }, [_c('span', {
    staticClass: "heartbit"
  }), _vm._v(" "), _c('span', {
    staticClass: "point"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63391a86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/main.vue
// module id = 1288
// module chunks = 169